import { render, staticRenderFns } from "./resourceStoreManageList.vue?vue&type=template&id=46d98d1e&scoped=true"
import script from "./resourceStoreManageList.vue?vue&type=script&lang=js"
export * from "./resourceStoreManageList.vue?vue&type=script&lang=js"
import style0 from "./resourceStoreManageList.vue?vue&type=style&index=0&id=46d98d1e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46d98d1e",
  null
  
)

export default component.exports